<template>
  <quill-editor
    ref="editor"
    :value="internalHtml"
    :options="options"
    :disabled="disabled"
    @input="handleInput"
    @change="(...args) => $emit('change', ...args)"
    @ready="handleReady"
    @blur="(...args) => $emit('blur', ...args)"
    @focus="(...args) => $emit('focus', ...args)"
  />
</template>

<script>
import { serializePhotoShortcodesHtml } from '@/utils/photo-shortcode-quill'

export default {
  name: 'AdminQuillEditor',
  props: {
    value: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      quill: null,
      internalHtml: '',
      lastEmitted: null,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(nextValue) {
        const normalized = nextValue || ''
        if (normalized === this.lastEmitted) {
          return
        }
        this.internalHtml = normalized
      },
    },
  },
  methods: {
    handleInput(html) {
      const serialized = serializePhotoShortcodesHtml(html)
      this.lastEmitted = serialized
      this.$emit('input', serialized)
    },
    handleReady(quill) {
      this.quill = quill
      this.$emit('ready', quill)
    },
  },
}
</script>
